import RegisterForm from "../components/register/register-form";
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { useTranslation } from 'react-i18next';
import LogoComponent from "../components/logo-comp";
import PageBackground from "../components/background-component";

const RegisterPage = () => {
    const { t } = useTranslation();  
    return (
        <div className="pg-form pg-reg page-bg">
            <div className="page-wrapper">
                <PageBackground
                    desktop={{
                    avif: `${process.env.PUBLIC_URL}/img/page-bg-reg.avif`,
                    webp: `${process.env.PUBLIC_URL}/img/page-bg-reg.webp`,
                    jpg: `${process.env.PUBLIC_URL}/img/page-bg-reg.jpg`
                    }}
                    mobile={{
                    avif: `${process.env.PUBLIC_URL}/img/page-bg-reg.avif`,
                    webp: `${process.env.PUBLIC_URL}/img/page-bg-reg.webp`,
                    jpg: `${process.env.PUBLIC_URL}/img/page-bg-reg.jpg`
                    }}
                />
                <Row className="mb-3">
                    {/* <Col md="6" className="margin-0 form-bg-out">
                        <div className="form-bg"></div>
                    </Col> */}
                    <Col md="12" className="margin-0">
                        <div className='bl-form bl-form-bg'>
                            <LogoComponent logoColor="white" />
                            <h1>Material Hub</h1>
                            <h2>{t('forms.register')}</h2>
                            <RegisterForm />
                        </div>
                    </Col>
                </Row>
            </div>
            {/* <div className="flex-box">
                <div >

                </div>
                <div>
                    <div className="align-center">
                        <img src="./img/Logo1.png" />
                    </div>
                    <h1>Регистрация</h1>
                    <RegisterForm />
                </div>
            </div> */}
        </div>
    )
}

export default RegisterPage;